// This file contains route definitions to be used in react/ts
// These are manually added as needed

// Utils & Prefixes
const API_VERSION = 'v2';
const API_PREFIX = `/api/browser/${API_VERSION}`;
const WEB_PREFIX = '/';

const routes = {
  /*
  |--------------------------------------------------------------------------
  | API
  |--------------------------------------------------------------------------
  */

  // Listings
  apiSearchPreview: (type: string) => `${API_PREFIX}/listing/${type}/search-preview`,

  /*
  |--------------------------------------------------------------------------
  | Web
  |--------------------------------------------------------------------------
  */

  // Search
  webSearch: (query?: string) => `${WEB_PREFIX}puppy-search${query ? `?query=${query}` : ''}`,
  webStudSearch: (query?: string) => `${WEB_PREFIX}breeds/type/stud`,
  webBreederSearch: (query?: string) => `${WEB_PREFIX}breeders-search`,

  // Breeds
  WEB_BREEDS_INDEX: `${WEB_PREFIX}breeds`,

};

export default routes;
